import { ConfigProvider } from 'antd'
import { createContext, useContext, useEffect } from 'react'
import { ErrorBoundary } from '../components/ErrorBoundary'
import { useSetup } from '../hooks/useSetup'
import { ThemeSetter, useTheme } from '../hooks/useTheme'
import { useViewport } from '../hooks/useViewport'

import '@ant-design/v5-patch-for-react-19'
import { useTouchDevice } from '../hooks/usTouchDevice'

const useInternal = () => {
  const theme = useTheme()
  const viewport = useViewport()
  const setup = useSetup()
  const touchDevice = useTouchDevice()

  const values = { ...theme, ...setup, ...viewport, ...touchDevice }

  useEffect(() => {
    if (theme.themeKey) {
      setup.setReady()
    }
  }, [theme.themeKey])

  return values
}

type Context = ReturnType<typeof useInternal>

const Context = createContext<Context>(undefined)

export const useDesignSystem = (): Context => {
  return useContext(Context)
}

export const DesignSystemProvider = ({ children }) => {
  const values = useInternal()

  return (
    <ErrorBoundary>
      <ConfigProvider theme={values.theme}>
        <Context.Provider value={values}>
          <ThemeSetter>{values.isReady ? children : <></>}</ThemeSetter>
        </Context.Provider>
      </ConfigProvider>
    </ErrorBoundary>
  )
}
